<template>
  <v-form class="box" ref="form" v-if="order">
    <template>
      <div class="box-method">
        <div class="row p-0">
          <div class="box-row col-12 p-0">
            <h6>VALOR</h6>
            <span class="price">R$ {{ order.amount | integerToMoney | integerToMoney2 }}</span>
          </div>
        </div>
        <div class="row p-0">
          <div class="box-row col-12 p-0">
            <h6>TAXA</h6>
            <span class="price">R$ {{ order.tax | integerToMoney | integerToMoney2 }}</span>
          </div>
        </div>
        <div class="row p-0">
          <div class="box-row col-12 p-0">
            <h6>VALOR TOTAL</h6>
            <span class="price">R$ {{ order.total_amount | integerToMoney | integerToMoney2 }}</span>
          </div>
        </div>
      </div>
      <div class="content-method">
        <div class="row p-0">
          <div class="box-row col-12 p-0">
            <h6>MÉTODO DE PAGAMENTO</h6>
            <span class="price">{{ order.payment_form.name }}</span>
          </div>
        </div>
        <div class="row p-0" v-if="order.payment_form.id === 5">
          <div class="box-row col-12 col-md-4 p-0">
            <h6>CEP</h6>
            <span>{{ details.method_payment.boleto.cep }}</span>
          </div>
          <div class="box-row col-12 col-md-8 p-0">
            <h6>ENDEREÇO</h6>
            <span>
              {{ details.method_payment.boleto.address + ', ' }}
              {{ details.method_payment.boleto.number + ' - ' }}
              {{ details.method_payment.boleto.district + ' | ' }}
              {{ details.method_payment.boleto.city + ' -' }}
              {{ details.method_payment.boleto.uf }}
            </span>
          </div>
        </div>
        <div class="row p-0" v-else-if="[2,3].includes(order.payment_form.id)">
          <div class="box-row col-12 col-md-6 p-0">
            <h6>NÚMERO DO CARTÃO</h6>
            <span>{{ details.method_payment.card.number }}</span>
          </div>
          <div class="box-row col-12 col-md-6 p-0">
            <h6>NOME IMPRESSO NO CARTÃO</h6>
            <span>{{ details.method_payment.card.card_holder }}</span>
          </div>
          <div class="box-row col-12 col-md-6 p-0" v-if="order.payment_form.id === 3">
            <v-alert type="error" color="#e72c1f">
              Caso ocorra algum erro nesta transação, entre em contato com sua agência bancária para
              liberar compras online com seu cartão.
            </v-alert>
          </div>
        </div>
      </div>
      <div class="content-method">
        <div class="row p-0">
          <div class="box-row col-12 p-0">
            <h6>PLACA</h6>
            <span class="price">{{ details.notification.plate }}</span>
          </div>
        </div>
        <div class="row p-0">
          <div class="box-row col-12 p-0">
            <h6>DATA DA IRREGULARIDADE</h6>
            <span class="price">{{ new Date(details.notification.date_time).toLocaleString() }}</span>
          </div>
        </div>

        <div class="row p-0" v-if="order.payment_form.id === 5">
          <div class="box-row col-12 col-md-4 p-0">
            <h6>CEP</h6>
            <span>{{ details.method_payment.boleto.cep }}</span>
          </div>
          <div class="box-row col-12 col-md-8 p-0">
            <h6>ENDEREÇO</h6>
            <span>
              {{ details.method_payment.boleto.address + ', ' }}
              {{ details.method_payment.boleto.number + ' - ' }}
              {{ details.method_payment.boleto.district + ' | ' }}
              {{ details.method_payment.boleto.city + ' -' }}
              {{ details.method_payment.boleto.uf }}
            </span>
          </div>
        </div>
        <div class="row p-0" v-else-if="[2,3].includes(order.payment_form.id)">
          <div class="box-row col-12 col-md-6 p-0">
            <h6>NÚMERO DO CARTÃO</h6>
            <span>{{ details.method_payment.card.number }}</span>
          </div>
          <div class="box-row col-12 col-md-6 p-0">
            <h6>NOME IMPRESSO NO CARTÃO</h6>
            <span>{{ details.method_payment.card.card_holder }}</span>
          </div>
          <div class="box-row col-12 col-md-6 p-0" v-if="order.payment_form.id === 3">
            <v-alert type="error" color="#e72c1f">
              Caso ocorra algum erro nesta transação, entre em contato com sua agência bancária para
              liberar compras online com seu cartão.
            </v-alert>
          </div>
        </div>
      </div>
    </template>
    <div class="col-12 p-0" v-if="renderBonus && details.notification.bonus">
      <v-alert type="info" v-if="details.notification.bonus.hasBonus" dismissible>
        Com direito ao bônus
      </v-alert>
      <v-alert type="warning" v-else-if="details.notification.bonus.deniedBonusDescription" dismissible>
        {{details.notification.bonus.deniedBonusDescription}}
      </v-alert>
    </div>
  </v-form>
</template>

<script>

export default {
  name: "ResumeRegularize",
  props: [
    'details',
    'order',
  ],
  data: function () {
    return {}
  },
  methods: {
    integerToMoney2(value) {
      let val = (value / 1).toFixed(2).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
  computed: {
    renderBonus(){
      return !!process.env.VUE_APP_RENDER_REGULARIZATION_BONUS;
    }
  }

}
</script>

<style scoped>
h6 {
  text-transform: uppercase;
  font-size: 12px;
  font-family: Roboto-Light;
  color: #a8a8a8;
  margin: 0;
}

.box-row {
  margin: 10px 0;
}

.box-row span {
  font-family: Roboto-Black;
  color: #000 !important;
  font-size: 14px;
}

span.price {
  font-size: 24px;
}

.details {
  text-align: center;
  margin: 15px 0;
  padding: 15px;
  border-top: 1px dashed #a8a8a8;
  border-bottom: 1px dashed #a8a8a8;
}

.box {
  display: flex;
  flex-wrap: wrap;
}

.box-method, .content-method {
  padding: 15px;
}

.box-method {
  width: 250px;
  background: transparent;
  border-radius: 4px;
  display: block;
}

.content-method {
  flex: 1;
}

</style>
